import { render } from "./ImageLoader.vue?vue&type=template&id=1972bdc7&scoped=true"
import script from "./ImageLoader.vue?vue&type=script&lang=js"
export * from "./ImageLoader.vue?vue&type=script&lang=js"

import "./ImageLoader.vue?vue&type=style&index=0&id=1972bdc7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1972bdc7"]])

export default __exports__